<template>
  <div>
    <div class="mask"></div>
    <div class="finish_scan_layer bounceIn">
      <p>
         <i class="dialogImg iconfont">
           <i></i>
         </i>
      </p>
      <p class="finish_tip">{{dialog.info}}</p>
      <p v-if="!dialog.twoButton" @click="confirm">确定</p>
      <div class="box_Button" v-if="dialog.twoButton">
        <span @click="confirm">确&nbsp;&nbsp;定</span>
        <span @click="cancel" style="margin-left:1rem;">取消</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["dialog"])
  },
  methods: {
    ...mapMutations(["set_dialog"]),
    close() {
      this.set_dialog({
        info: "",
        show: false
      });
    },
    confirm() {
      this.dialog.resolveFn();
    },
    cancel() {
      this.dialog.rejectFn();
    }
  }
};
</script>
